import { render, staticRenderFns } from "./UploadBiometricId.vue?vue&type=template&id=993f67c8&scoped=true&"
import script from "./UploadBiometricId.vue?vue&type=script&lang=js&"
export * from "./UploadBiometricId.vue?vue&type=script&lang=js&"
import style0 from "./UploadBiometricId.vue?vue&type=style&index=0&id=993f67c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993f67c8",
  null
  
)

export default component.exports